const locale = {
	noNotifications: 'Jelenleg nincs semmilyen értesítő.',
	clearAll: 'összes törlése',
	open: 'Megnyit',
	notifications: 'Értesítők'
};
export default locale;
